(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./actions"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./actions"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.actions);
    global.reducers = mod.exports;
  }
})(this, function (exports, _actions) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.submissions = submissions;
  exports.searchMethod = searchMethod;
  exports.status = status;
  exports.children = children;
  exports.storedChildIds = storedChildIds;
  exports.child = child;
  exports.content = content;
  exports.descriptors = descriptors;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var EDITING = "EDITING",
      PROCESSING = "PROCESSING",
      ERROR = "ERROR",
      COMPLETE = "COMPLETE";


  var initialState = {
    status: EDITING,
    submissions: {},
    children: [],
    child: {},
    storedChildIds: {},
    errors: [],
    message: "",
    selectValue: 10,
    timeToLoad: "",
    searchMethod: "random",
    selectedCountry: "",
    selectedGender: "",
    selectedAge: "",
    selectedMonth: "",
    selectedDay: "",
    searchTerm: "",
    contentTiles: [{
      tileClass: "one-to-one",
      title: "One to One.",
      height: "25",
      content: "<p>Each child is matched with ONE unique sponsor. It could be you!</p>",
      background: "purple-orange-gradient",
      backgroundImage: "",
      position: 1
    }, {
      tileClass: "operating-ratio",
      title: "",
      height: "75",
      content: "<p>In 2020, we used <strong>88%</strong> of our total operating expenses for programs that benefit children, families, and communities.</p>",
      background: "purple-orange-gradient",
      backgroundImage: "https://wvusstatic.com/2021/sponsorship-app/thriftiness.svg",
      position: 2
    }, {
      tileClass: "clean-water",
      title: "",
      height: "33",
      content: "<p><strong>Your sponsorship helps children and their community with things like:</strong></p><ul><li>clean water</li><li>education</li><li>healthcare</li><li>nutrition</li><li>jobs for parents</li></ul>",
      background: "blue-green-gradient",
      backgroundImage: "",
      position: 3
    }, {
      tileClass: "donor-voice",
      title: "",
      height: "66",
      content: '<p>World Vision stands out as an organization with impeccable accountability, transparency and most importantly, effectiveness.</p><p class="quote">- Patricia Heaton,<br/>actress,<br/>mom,<br/>child sponsor</p>',
      background: "green-yellow-gradient",
      backgroundImage: "https://wvusstatic.com/2018/sponsorship-app/quote-marks.svg",
      position: 4
    }, {
      tileClass: "visit-child",
      title: "Did you Know?",
      height: "66",
      content: "<p>You can visit your sponsored child! If you want to meet your child in person, we’d love to help arrange a visit.</p>",
      background: "teal-green-gradient",
      backgroundImage: "https://wvusstatic.com/2018/sponsorship-app/globe.svg",
      position: 5
    }, {
      tileClass: "pen-pals",
      title: "Pen Pals Welcome.",
      height: "66",
      content: "<p>You don't have to write, but children LOVE getting letters. Plus, they'll write you back every time.</p>",
      background: "blue-green-gradient",
      backgroundImage: "https://wvusstatic.com/2018/sponsorship-app/envelope.svg",
      position: 6
    }, {
      tileClass: "community-based-solutions",
      title: "Bonus!",
      height: "75",
      content: "<p>Because of our community-focused solutions, <strong>for every child you help, 4 more children benefit, too.</strong><p>",
      background: "orange-gradient",
      backgroundImage: "https://wvusstatic.com/2018/sponsorship-app/kids.svg",
      position: 7
    }, {
      tileClass: "hope-of-help",
      title: "",
      height: "50",
      content: "<p>Here at World Vision<br/>EVERY 60 SECONDS &ndash;</br>a family receives the tools to overcome poverty</p>",
      background: "orange-gradient",
      backgroundImage: "",
      position: 8
    }, {
      tileClass: "how-long-sponsorship",
      title: "How long is your sponsorship?",
      height: "50",
      content: "<p>As long as you want. Sponsoring a child is a great opportunity for a long-term relationship.</p>",
      background: "teal-green-gradient",
      backgroundImage: "",
      position: 9
    }],
    //full list of descriptors...commented out due to sensative areas 10/20/21
    // descriptors: [
    //   "full of potential",
    //   "loved by God",
    //   "made in God’s image",
    //   "created to shine",
    //   "cherished by God",
    //   "who needs a believer",
    //   "full of hope",
    //   "who matters to God",
    //   "with possibilities",
    //   "created to dream",
    //   "who needs you",
    //   "worth investing in",
    //   "full of promise",
    //   "made to dream",
    //   "full of life",
    //   "and a child of God",
    //   "created to thrive",
    //   "ready for a sponsor",
    //   "whose life matters",
    //   "loved by Jesus",
    //   "ready to flourish",
    //   "created to shine",
    //   "who shines brightly",
    //   "full of possibility",
    // ],
    descriptors: ["full of potential", "created to shine", "who needs a believer", "full of hope", "with possibilities", "created to dream", "who needs you", "worth investing in", "full of promise", "made to dream", "full of life", "created to thrive", "ready for a sponsor", "whose life matters", "ready to flourish", "created to shine", "who shines brightly", "full of possibility"]
  };
  //flux standard action
  //  {
  //    type:"string",
  //    payload: "",
  //    error: "",
  //    metadata: ""
  //  }

  //handle submissions
  function submissions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.submissions;
    var action = arguments[1];

    switch (action.type) {
      case _actions.CLEAR_SUBMISSION:
        return _extends({}, state, _defineProperty({}, action.key, {
          request: {},
          response: {},
          error: null
        }));
      case _actions.SET_SUBMISSIONS_REQUEST:
        return _extends({}, state, _defineProperty({}, action.key, _extends({}, state[action.key], {
          request: action.data,
          response: {},
          error: null
        })));
      case _actions.SET_SUBMISSIONS_RESPONSE:
        return _extends({}, state, _defineProperty({}, action.key, _extends({}, state[action.key], {
          response: action.data,
          responseData: action.responseData,
          error: action.error
        })));
      default:
        return state;
    }
  }
  function searchMethod() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.searchMethod;
    var action = arguments[1];

    switch (action.type) {
      case _actions.UPDATE_SEARCH_METHOD:
        return action.payload;
    }
    return state;
  }
  function status() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
    var action = arguments[1];

    switch (action.type) {
      case _actions.UPDATE_STATUS:
        return action.payload;
    }
    return state;
  }
  function children() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.children;
    var action = arguments[1];

    switch (action.type) {
      case _actions.SET_CHILDREN:
        return _extends({}, state, action.payload);
      default:
        return state;
    }
  }
  function storedChildIds() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.storedChildIds;
    var action = arguments[1];

    switch (action.type) {
      case _actions.SET_CHILD_IDS:
        return _extends({}, state, _defineProperty({}, action.key, action.payload));
      default:
        return state;
    }
  }
  function child() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.child;
    var action = arguments[1];

    switch (action.type) {
      case _actions.SET_CHILD:
        return _extends({}, state, _defineProperty({}, action.key, action.payload));
      default:
        return state;
    }
  }
  function content() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.contentTiles;
    var action = arguments[1];

    switch (action.type) {
      case _actions.GET_CONTENT:
        return _extends({}, state, _defineProperty({}, action.key, action.payload));
      default:
        return state;
    }
  }
  function descriptors() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.descriptors;
    var action = arguments[1];

    switch (action.type) {
      case _actions.SET_DESCRIPTORS:
        return action.data;
      default:
        return state;
    }
  }

  exports.default = {
    submissions: submissions,
    status: status,
    searchMethod: searchMethod,
    storedChildIds: storedChildIds,
    child: child,
    children: children,
    content: content,
    descriptors: descriptors,
    initialState: initialState
  };
});